import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store/modules';

import AnonymousRouter from './router/anonymouse/AnonymousRouter';
import { AdminRouter } from './router/admin/AdminRouter';
import { ManagerRouter } from './router/user/ManagerRouter';
import { WorkerRouter } from './router/worker/WorkerRouter';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useWebsocket, WebsocketProvider } from './hook/WebsocketContext';
import {
  setProductionData,
  increaseProductionCount,
  updateProductionData,
  setStockData,
  setStockHistoryData,
  updateStockHistoryData,
  addStockHistoryData,
  setUnsyncedStockHistoryData,
  updateUnsyncedStockHistoryData,
  addUnsyncedStockHistoryData,
} from './store/modules/socketData';
const ScreenProvider = () => {
  const location = useLocation();
  const loginUserData = useSelector((state: RootState) => state.loginUserData);
  const role = loginUserData?.role ? loginUserData?.role : 'ANONYMOUS';

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log('LOCATION:::', location);
  }, [location]);

  const { subscribe, connectSocket, isConnected } = useWebsocket();

  useEffect(() => {
    if (role !== 'ADMIN' && role !== 'MANAGER' && role !== 'WORKER') return;
    console.log('do subscribe');
    initializeWebSocket();
  }, [role]);

  async function initializeWebSocket() {
    try {
      await connectSocket();
      subscribe('/sub/production', (data) => {
        if (data.type === 'CREATED') {
          dispatch(setProductionData(data.data));
        } else if (data.type === 'INCREASED') {
          dispatch(increaseProductionCount(data.data));
        } else if (data.type === 'UPDATED') {
          dispatch(updateProductionData(data.data));
        }
      });
      subscribe('/sub/stock', (data) => {
        if (data.type === 'UPDATED') {
          dispatch(setStockData(data.data));
        }
      });
      subscribe('/sub/stock-history', (data) => {
        if (data.type === 'CREATED') {
          dispatch(setStockHistoryData(data.data));
        }
        if (data.type === 'UPDATED') {
          dispatch(updateStockHistoryData(data.data));
        }
        if (data.type === 'ADDED') {
          dispatch(addStockHistoryData(data.data));
        }
      });
      subscribe('/sub/unsynced-stock-history', (data) => {
        if (data.type === 'CREATED') {
          dispatch(setUnsyncedStockHistoryData(data.data));
        }
        if (data.type === 'UPDATED') {
          dispatch(updateUnsyncedStockHistoryData(data.data));
        }
        if (data.type === 'ADDED') {
          dispatch(addUnsyncedStockHistoryData(data.data));
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  return role === 'ADMIN' ? (
    <AdminRouter />
  ) : role === 'MANAGER' ? (
    <ManagerRouter />
  ) : role === 'WORKER' ? (
    <WorkerRouter />
  ) : (
    <AnonymousRouter />
  );
};

export default ScreenProvider;
